import React from "react"
import styled from "styled-components"
import P from "../../../typography/P"
import H3 from "../../../typography/H3"
import Container from "../../Container"
import ImageWrapper from "../../ImageWrapper"
import Section from "../../Section"
import TextWrapper from "../../TextWrapper"
import { ListItem, UnorderedList } from "../../UnorderedLists"
import CheckMark from "../../../../images/home/check.svg"
import IconHeadingTitle from "../../IconHeadingTitle"
import buildHighConvertingOffersData from "../../../../data/pageSections/platform/offers/highConvertingOffers"

const CustomTextWrapper = styled(TextWrapper)`
  ${({ theme }) => theme.desktop`
  order: 1;
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: row;
  margin-bottom: 50px;
  justify-content: space-between;

  p {
    width: 48%;
  }
  `}
`

const CustomIconHeadingTitle = styled(IconHeadingTitle)`
  ${({ theme }) => theme.desktop`
    width: 50%;
  `}
`

const CustomImageWrapper = styled(ImageWrapper)`
  ${({ theme }) => theme.desktop`
    order: 2;
    width: 80%;
    margin-bottom: 50px;
  `}
`

const BenefitsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  order: 4;
`

const StyledH3 = styled(H3)`
  ${({ theme }) => theme.se`
    font-size: 18px;
    text-align: center;
  `}
`

const Benefit = styled.div`
  h3 {
    display: flex;
    align-items: center;
    text-align: left;
  }
  img {
    margin-bottom: 0;
  }

  ${({ theme }) => theme.se`
    width: 100%;
  `}

  ${({ theme }) => theme.desktop`
    width: 48%;
  `}
`

const BuildHighConvertingOffersWithEase = () => {
  const {
    titleIcon,
    title,
    description,
    graphic,
    imageLeft,
    benefits,
    tint,
    clipPath,
    textLong,
    builderElementSections,
  } = buildHighConvertingOffersData

  return (
    <Section tint={tint} clipPath={clipPath} className="padding-tb-0">
      <Container>
        <CustomTextWrapper imageLeft={imageLeft} long={textLong}>
          <CustomIconHeadingTitle icon={titleIcon} title={title} />
          {description}
        </CustomTextWrapper>
        <CustomImageWrapper imageLeft={imageLeft} short={textLong}>
          {graphic}
        </CustomImageWrapper>
        <BenefitsWrapper>
          {benefits.map(({ benefitDescription, benefitTitle }) => (
            <Benefit>
              <StyledH3>
                <img src={CheckMark} /> {benefitTitle}
              </StyledH3>
              <P>{benefitDescription}</P>
            </Benefit>
          ))}
        </BenefitsWrapper>
      </Container>
    </Section>
  )
}

export default BuildHighConvertingOffersWithEase
